import * as React from 'react';
import { Button } from '../Button';
import { plural } from '@cian/utils/lib/shared/plural';
import * as styles from './SearchButton.css';
import { Preloader } from '@cian/preloader-component';

export interface ISearchButtonProps extends React.HTMLProps<HTMLButtonElement> {
  count?: number | null;
  isCountFetching?: boolean;
  onClick(event?: React.SyntheticEvent): void;
}

export const SearchButton = ({ count, onClick, isCountFetching = false }: ISearchButtonProps) => {
  const searchButtonVariants: [string, string, string] = ['предложение', 'предложения', 'предложений'];
  const searchButtonLabelText = 'Показать предложения';

  const searchButtonLabel = typeof count === 'number'
    ? `Показать ` +
    `${count} ${plural(count, searchButtonVariants)}`
    : searchButtonLabelText;

  return(
    <Button
      className={styles['search_button']}
      dataMark="SearchButton"
      type="primary"
      htmlType="submit"
      onClick={onClick}
    >
      {isCountFetching && <div className={styles['search_button--preloader']}><Preloader size={20} /></div>}
      {searchButtonLabel}
    </Button>
  );
};
